export default __webpack_public_path__ + "static/media/bear-1k.241e527e.glb";